import { render, staticRenderFns } from "./hospitalexam.vue?vue&type=template&id=e3d28260&scoped=true&"
import script from "./hospitalexam.vue?vue&type=script&lang=js&"
export * from "./hospitalexam.vue?vue&type=script&lang=js&"
import style0 from "./hospitalexam.vue?vue&type=style&index=0&id=e3d28260&lang=less&scoped=true&"
import style1 from "./hospitalexam.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d28260",
  null
  
)

export default component.exports